module.exports = __webpack_public_path__ + "img/demand.af9b1b7b.svg";